import { of } from 'rxjs';

export class AngularFireAuthStub {
  user = {};
  get authState() {
    return of(null);
  }
}
